import React, { Component } from 'react'
import axios from 'axios'

import moment from 'moment'

export class DashBoardModal extends Component {
  state = {
    departmentLists: [],
    selectedDepartment: '',
    department: ['']
  }

  render () {
    // This is the validation if date is exceeded (Leap year is included)

    let invalid = this.props.grid
    // for (let i = 0; i < invalid.length; i++) {
    //   invalid[i][8].isValid = false
    //   let dateIsExceeded =
    //     new Date(invalid[i][8].value.match('^\\d{2}/\\d{2}/\\d{4}$')) >=
    //     moment(invalid[i][6].date).startOf('day')._d
    //   if (invalid[i][8].value !== '' && invalid[i][8].value !== 'Posting Date')
    //       
    //   if (
    //     parseInt(
    //       `${new Date(
    //         invalid[i][8].value.match('^\\d{2}/\\d{2}/\\d{4}$')
    //       )}`.substring(7, 10)
    //     ) === parseInt(invalid[i][8].value.substring(3, 5)) &&
    //     dateIsExceeded
    //   ) {
    //     invalid[i][8].isValid = true
    //   }
    // }

    const invalidData = invalid.filter(
      crf =>
        (crf[7].value.trim() !== '' && crf[8].value === '') ||
        (crf[7].value.trim().length !== 9 &&
          crf[7].value.trim() !== 'APV#' &&
          crf[8].value !== '' &&
          crf[8].value !== 'Posting Date') ||
        (!crf[8].value.match('^\\d{2}/\\d{2}/\\d{4}$') &&
          crf[7].value.trim() !== 'APV#' &&
          crf[8].value !== '' &&
          crf[8].value !== 'Posting Date') ||
        (isNaN(crf[7].value.trim()) &&
          crf[7].value.trim() !== 'APV#' &&
          crf[8].value !== '' &&
          crf[8].value !== 'Posting Date') ||
        (isNaN(new Date(crf[8].value.match('^\\d{2}/\\d{2}/\\d{4}$'))) &&
          crf[7].value.trim() !== 'APV#' &&
          crf[8].value !== '' &&
          crf[8].value !== 'Posting Date') ||
        (crf[8].isValid === false &&
          crf[7].value.trim() !== 'APV#' &&
          crf[8].value !== '' &&
          crf[8].value !== 'Posting Date') ||
        (!Number.isInteger(parseFloat(crf[7].value.trim())) &&
          crf[7].value.trim() !== 'APV#' &&
          crf[8].value !== '' &&
          crf[8].value !== 'Posting Date') ||
        (`${crf[7].value.trim()}`.charAt(0) !== '1' &&
          crf[7].value.trim() !== '' &&
          crf[7].value.trim() !== 'APV#' &&
          crf[8].value !== 'Posting Date')
    )

    const gridWithInput = this.props.grid.filter(
      crf =>
        crf[7].value.trim() !== '' &&
        crf[7].value.trim() !== 'APV#' &&
        crf[8].value !== '' &&
        crf[8].value !== 'Posting Date'
    )

    return (
      <div id='modalBody' className='modalBody'>
        <div className='modalContainer'>
          <div className='modalbg'>
            <div id='modalContentDashboard'>
              <div className='updatingChecksContainer'>
                {gridWithInput.length === 0 && invalidData.length === 0 ? (
                  <>
                    <h4 className='returnHeader'>Nothing To Update</h4>
                  </>
                ) : (
                  <>
                    {invalidData.length === 0 && gridWithInput.length !== 0 ? (
                      <>
                        <h4>Update to Check Preparation</h4>
                        <h5 className='returnHeader'>
                          Please make sure that you already downloaded the csv
                          file or else CRF will not be updated.
                        </h5>
                      </>
                    ) : (
                      <h4>Error</h4>
                    )}
                  </>
                )}

                {invalidData.map(crf => (
                  <div className='updatingChecksContent'>
                    <div className='inProcessCrfDetail'>
                      <span>CRF#:{crf[3].value}</span>
                    </div>
                    <div className='inProcessCrfDetail'>
                      <span
                        style={
                          crf[7].value.trim().length !== 9 ||
                          isNaN(crf[7].value.trim()) ||
                          !Number.isInteger(parseFloat(crf[7].value.trim())) ||
                          `${crf[7].value.trim()}`.charAt(0) !== '1'
                            ? textRed
                            : null
                        }
                      >
                        APV#:
                        {crf[7].value.trim().length !== 9 ||
                        isNaN(crf[7].value.trim()) ||
                        !Number.isInteger(parseFloat(crf[7].value.trim())) ||
                        `${crf[7].value.trim()}`.charAt(0) !== '1'
                          ? crf[7].value.trim() === ''
                            ? 'Empty'
                            : 'invalid'
                          : crf[7].value.trim()}
                      </span>
                    </div>
                    <div className='inProcessCrfDetail'>
                      <span
                        style={
                          crf[8].value === '' ||
                          !crf[8].value.match('^\\d{2}/\\d{2}/\\d{4}$') ||
                          isNaN(
                            new Date(
                              crf[8].value.match('^\\d{2}/\\d{2}/\\d{4}$')
                            )
                          ) ||
                          crf[8].isValid === false
                            ? textRed
                            : null
                        }
                      >
                        Posting Date:
                        {crf[8].value === '' ? 'Empty' : null}
                        {crf[8].value.match('^\\d{2}/\\d{2}/\\d{4}$')
                          ? !isNaN(
                              new Date(
                                crf[8].value.match('^\\d{2}/\\d{2}/\\d{4}$')
                              )
                            )
                            ? crf[8].isValid === true
                              ? crf[8].value
                              : 'invalid'
                            : 'Invalid'
                          : crf[8].value !== ''
                          ? 'Invalid'
                          : null}
                      </span>
                    </div>
                  </div>
                ))}
              </div>
              {gridWithInput.length === 0 && invalidData.length === 0 ? null : (
                <>
                  {invalidData.length === 0 &&
                  gridWithInput.length !== 0 ? null : (
                    <div className='returnHeader'>
                      <h6>Apv number must be 9 numerical characters.</h6>
                      <h6>Date must be valid and in mm/dd/yy format</h6>
                    </div>
                  )}
                </>
              )}

              <div className='updateToCheckPrepareButtonContainer'>
                {gridWithInput.length === 0 && invalidData.length === 0 ? (
                  <>
                    <button
                      className='updateToCheckPrepareCloseButton'
                      onClick={this.props.closeModal}
                    >
                      Ok
                    </button>
                  </>
                ) : (
                  <>
                    {invalidData.length === 0 && gridWithInput.length !== 0 ? (
                      <>
                        <button
                          className='updateToCheckPrepareCloseButton'
                          onClick={this.props.closeModal}
                        >
                          Cancel
                        </button>
                        <button
                          className='updateToCheckPrepareUpdateButton'
                          onClick={this.props.handleUpdateToCheckPreparation}
                        >
                          Confirm
                        </button>
                      </>
                    ) : (
                      <button
                        className='updateToCheckPrepareCloseButton'
                        onClick={this.props.closeModal}
                      >
                        Close
                      </button>
                    )}
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

const textRed = {
  color: 'red'
}

export default DashBoardModal
